var o_order = window.o_order || {};
o_order.performancemarketing = o_order.performancemarketing || {};
o_order.performancemarketing.data = o_order.performancemarketing.data || {};

o_order.performancemarketing.data.buildBasketDataFactory = function (data) {
    return function () {
        var element = document.getElementsByClassName('order_js_performanceMarketingData')[0];
        if (!!element && !!data) {
            data.pt = element.getAttribute('data-pt');
            window.o_order.utils.activateFeatureCompleted('exactag-basket');
        }
    };
};
